<template>
    <div class="order-tmp">
        <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">工单凭单信息</div>
        <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
            <tbody class="body">
            <tr class="row">
                <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    基本信息

                </td>
            </tr>
            <tr class="row">
                <!--<td rowspan="5">基本信息</td>-->
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">工单编号</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.no}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">工单类型</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcTypeMap[servcWorkVoucher.servcType]}}


                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">交易单号</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.tradeNo}}</div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">紧急状态</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{emgLevelMap[servcWorkVoucher.emgLevel]}}


                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">工单模式</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.grabFlag ? '抢单' : '指派'}}


                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">工单状态</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-if="servcWorkVoucher.closed">已关闭</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-else-if="servcWorkVoucher.invalid">已作废</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-else-if="servcWorkVoucher.state == 7">
                            服务暂停(原因:' + {{servcWorkVoucher.stateDesc}}+ '


                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-else>{{stateInfoMap[servcWorkVoucher.state]}}</div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">请求单号</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-if="servcWorkVoucher.reqVoucherId != null && servcWorkVoucher.reqVoucherId != -1">
                            <span>{{servcWorkVoucher.reqVoucherNo}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">请求时间</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-if="servcWorkVoucher.reqVoucherId != null && servcWorkVoucher.reqVoucherId != -1">
                            <span>{{servcWorkVoucher.requestTime}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">工单创建时间


                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.createTime}}</div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">工单创建人


                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.creatorName}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">指派网点

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-if="servcWorkVoucher.servicerShopId == null">
                            未指派
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-else>
                            {{servcWorkVoucher.manualShopFlag ? '手工' : '自动'}}
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">指派工程师

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-if="servcWorkVoucher.engineerId == null">
                            未指派
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-else>
                            {{servcWorkVoucher.manualEngFlag ? '手工' : '自动'}}
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">是否确定期保外

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-if="servcWorkVoucher.beyondWrnt">交易约定外</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-else>交易约定内</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">仅报修人验收

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-if="servcWorkVoucher.acceptByRequester">是

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-else>否</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">业务标签</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.retailerTag}}</div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item clearfix">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">截止时间</div>
                        <div class="value" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;">
                            {{servcWorkVoucher.yqFinishTime}}

                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">

                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">

                </td>
            </tr>
            </tbody>
            <tbody class="body">
            <tr class="row">
                <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: color: #666;font-size:12px;;">
                    设备信息

                </td>
            </tr>
            <tr class="row">
                <!--<td rowspan="4">服务信息</td>-->
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">系统编号</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.tmpNo || '无'}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">商品标识码

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.vendorUkno || '无'}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">设备名称</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            {{servcWorkVoucher.deviceName || '无'}}

                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">设备分类</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            {{servcWorkVoucher.deviceCatName || '无'}}

                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">维保分组</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            {{servcWorkVoucher.devcGroupFullName || '无'}}

                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">设备品牌</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.deviceBrandName || '无'}}

                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">所在部门</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.departName || '无'}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">部件名称</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span v-for="(servcWorkDevicePart, index) in servcWorkVoucher.servcWorkDeviceParts">{{servcWorkDevicePart.partName}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;"></td>
            </tr>
            </tbody>
            <tbody class="body">
            <tr class="row" v-if="(servcWorkVoucher.servcWorkAccItemList != null &&　servcWorkVoucher.servcWorkAccItemList.length>0 ) || (servcWorkVoucher.shareAccFlag && servcWorkVoucher.servcWorkShareAccItemList != null &&　servcWorkVoucher.servcWorkShareAccItemList.length > 0)">
                <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    配件信息


                </td>
            </tr>
            <template v-if="servcWorkVoucher.servcWorkAccItemList != null &&　servcWorkVoucher.servcWorkAccItemList.length > 0">
                <tr class="row" v-for="servcWorkAccItem in servcWorkVoucher.servcWorkAccItemList">
                    <!--<td>费用信息</td>-->
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item clearfix">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">配件名称


                            </div>
                            <div class="value" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;">
                                {{servcWorkAccItem.accName}}


                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item clearfix">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">个数


                            </div>
                            <div class="value" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;">
                                {{servcWorkAccItem.quantity || '无'}}


                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item clearfix">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">单位


                            </div>
                            <div class="value" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;">
                                <span>{{servcWorkAccItem.unit}}</span>
                            </div>
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="servcWorkVoucher.shareAccFlag && servcWorkVoucher.servcWorkShareAccItemList != null &&　servcWorkVoucher.servcWorkShareAccItemList.length > 0">
                <tr class="row" v-for="servcWorkShareAccItem in servcWorkVoucher.servcWorkShareAccItemList">
                    <!--<td>费用信息</td>-->
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item clearfix">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">配件名称


                            </div>
                            <div class="value" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;">
                                {{servcWorkShareAccItem.accName}}


                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item clearfix">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">个数


                            </div>
                            <div class="value" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;">
                                {{servcWorkShareAccItem.quantity || '无'}}


                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item clearfix">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">单位


                            </div>
                            <div class="value" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;">
                                <span>{{servcWorkShareAccItem.unit}}</span>
                            </div>
                        </div>
                    </td>
                </tr>
            </template>
            <tr class="row">
                <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    费用信息

                </td>
            </tr>
            <tr class="row">
                <!--<td>费用信息</td>-->
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">上门费（元）

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-if="servcWorkVoucher.toDoorFee != null">
                            {{servcWorkVoucher.toDoorFee}}

                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">服务费（元）

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-if="servcWorkVoucher.finished">
                            {{servcWorkVoucher.generallFee || '无'}}

                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">配件费（元）

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;" v-if="servcWorkVoucher.accFee != null && servcWorkVoucher.servcWorkAccItemList != null &&　servcWorkVoucher.servcWorkAccItemList.length>0">
                            <span>{{servcWorkVoucher.accFee}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <!--<td>费用信息</td>-->
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item clearfix">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">总费用（元）


                        </div>
                        <div class="value" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;">
                            {{servcWorkVoucher.amount}}


                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item clearfix">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <sapn>是否免费</sapn>
                        </div>
                        <div class="value" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;">
                            <span class="swb-tags swb-tags-success" v-if="servcWorkVoucher.freeFlag">免费</span>
                            <span class="swb-tags swb-tags-danger" v-else>收费</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;"></td>
            </tr>
            </tbody>
            <tbody class="body">
            <tr class="row">
                <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    请求信息

                </td>
            </tr>
            <tr class="row">
                <!--<td rowspan="6">请求信息</td>-->
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">服务请求方

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.buyerName}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">请求机构</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.buyerShopName}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">请求人</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.requesterStaffName}}</div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">请求人电话

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.requesterContactTel}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">请求地址</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.buyerShopAddr}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">请求机构联系电话

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.buyerShopContactTel}}</div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">请求描述</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.requestDesc || '无'}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">情况描述</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.troubleDesc}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">预约上门时间

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.planTime || '无'}}</div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            要求响应时间（分钟）

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.yqRspTimeMi || '无'}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            要求到达时间（分钟）

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.yqArriveTimeMi || '无'}}

                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">要求完成时长(分钟)

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.yqRepairedTimeMi || '无'}}

                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">计划出发时间

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.planStartOffTime || '无'}}

                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">预计完成时间

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.estiFinishTime || '无'}}

                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            实际响应时长（分钟）

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.rspTimeMi || '无'}}</div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            实际到达时长（分钟）

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.arriveTimeMi || '无'}}

                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            实际完成时长（分钟）

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.repairedTimeMi || '无'}}

                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            要求回询时限（分钟）

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.reqTelCallTimeMi || '无'}}

                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            实际回询时限（分钟）

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.rspTelCallTimeMi || '无'}}

                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">

                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">

                </td>
            </tr>
            </tbody>
            <tbody class="body">
            <tr class="row">
                <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    服务网点信息

                </td>
            </tr>
            <tr class="row">
                <!--<td rowspan="2">服务网点信息</td>-->
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">服务商名称

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.servicerName}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">服务网点名称

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.servicerShopName}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">网点联系电话

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            {{servcWorkVoucher.servicerShopContractTel || '无'}}

                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">网点联系人

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            {{servcWorkVoucher.servicerShopContractName || '无'}}

                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;"></td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;"></td>
            </tr>
            </tbody>
            <tbody class="body">
            <tr class="row">
                <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    工程师信息

                </td>
            </tr>
            <tr class="row">
                <!--<td rowspan="2">工程师信息</td>-->
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">主工程师</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.engineerName || '无'}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">辅助工程师

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.engineerNames || '无'}}

                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">主工程师联系电话

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{servcWorkVoucher.contactTel || '无'}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">到达时间</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{servcWorkVoucher.toDoorTime || '无'}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;"></td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;"></td>
            </tr>
            <tr class="row">
                <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    处理信息

                </td>
            </tr>
            <tr class="row">
                <!--<td rowspan="2">工程师信息</td>-->
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">故障类型</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.faultTypeName || '无'}}
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">故障描述

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{servcWorkVoucher.faultDesc || '无'}}

                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">维修类型

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{servcWorkVoucher.repairTypeName || '无'}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">服务完成时间
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{servcWorkVoucher.finishTime || '无'}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">处理结果</div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{servcWorkVoucher.handleResult || '无'}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;"></td>
            </tr>
            </tbody>
        </table>
        <template v-if="servcWorkVoucher.finished && (servcWorkVoucher.servcType == 0 || servcWorkVoucher.servcType == 1 || servcWorkVoucher.additionFlag)">
            <swb-servc-work-add-item-list :id="voucherId" ref="swb_servc_work_add_item_list"></swb-servc-work-add-item-list>
        </template>
        <template v-if="servcWorkVoucher.devcInspectFlag && servcWorkVoucher.devcInspectInfo != null">
            <div class="order-tmp-caption" style="font-size: 15px;color: #1a1a1a;font-weight: 600;text-align: center;padding: 15px 0;">检验签字信息</div>
            <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size: 12px;">
                <tbody class="body">
                <tr class="row">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item clearfix">
                            <div class="label" style="width: 160px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>交出接收人</span>
                            </div>
                            <div class="value" style="float: left; width: calc(100% - 160px); width: -webkit-calc(100% - 160px);white-space: normal; word-break: break-all;">
                                <span>{{servcWorkVoucher.devcInspectInfo.handoverOutRcvName}}</span>
                            </div>
                        </div>
                        <div class="sign-name" style="height: 160px;text-align: center;">
                            <img style="height: 160px;" :src=" servcWorkVoucher.devcInspectInfo.handoverOutRcvSigUrl"/>
                        </div>
                        <div class="info-item clearfix">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>检验日期</span>
                            </div>
                            <div class="value align-right" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;">
                                <span>{{new Date(servcWorkVoucher.devcInspectInfo.inspectDate).format("yyyy年MM月dd日")}}</span>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item clearfix">
                            <div class="label" style="width: 160px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>交回接收人</span>
                            </div>
                            <div class="value" style="float: left; width: calc(100% - 160px); width: -webkit-calc(100% - 160px);white-space: normal; word-break: break-all;">
                                <span>{{servcWorkVoucher.devcInspectInfo.handoverInRcvName}}</span>
                            </div>
                        </div>
                        <div class="sign-name" style="height: 160px;text-align: center;">
                            <img style="height: 160px;" :src=" servcWorkVoucher.devcInspectInfo.handoverInRcvSigUrl"/>
                        </div>
                        <div class="info-item clearfix">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>检验日期</span>
                            </div>
                            <div class="value align-right" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;">
                                <span>{{new Date(servcWorkVoucher.devcInspectInfo.inspectDate).format("yyyy年MM月dd日")}}</span>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </template>
        <template v-if="servcWorkVoucher.devcMaintFlag">
            <swb-servc-work-devc-maint-voucher-list :id="voucherId" ref="swb_servc_work_devc_maint_voucher_list"></swb-servc-work-devc-maint-voucher-list>
        </template>
        <template v-if="servcWorkVoucher.servcType == 3">
            <swb-servc-work-check-voucher-voucher-list :id="voucherId" ref="swb_servc_work_check_voucher_voucher_list"></swb-servc-work-check-voucher-voucher-list>
        </template>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import { showHtmlToPdfDlg } from '../ctrl/dialog'
    //
    import servcDelivApi from '../../api/servcDeliv'
    //
    import SwbServcWorkAddItem from './ServcWorkAddItem';
    Vue.regist(SwbServcWorkAddItem);
    //
    import SwbDevcMaintVoucherPdf from './DevcMaintVoucherPdf'
    Vue.regist(SwbDevcMaintVoucherPdf);
    import SwbCheckWorkVoucherPdf from './CheckWorkVoucherPdf'
    Vue.regist(SwbCheckWorkVoucherPdf);

    export default {
        name: 'swb-servc-work-voucher-for-export',
        desc: '工单导出',
        props: {
            voucherId: {
                type: Number,
                deafult: null,
            },
        },
        data: function () {
            return {
                servcWorkVoucher: {},
                emgLevelMap: getEnumMap('emgLevel', 'value2text'),
                stateInfoMap: getEnumMap('workAssignState', 'value2text'),
                servcTypeMap: getEnumMap('servcType', 'value2text'),
                img: null,
            }

        },
        created: function () {
            this.getServcWorkVoucherById();
        },
        methods: {
            getServcWorkVoucherById: function () {
                let self = this;
                let postData = {};
                postData.id = self.voucherId;
                servcDelivApi.getServcWorkVoucherById(postData, function (result) {
                    if(result.type == "info") {
                        let servcWorkVoucher = result.data;
                        let engineerNameStr = servcWorkVoucher.engineerNames;
                        let engineerName = servcWorkVoucher.engineerName;
                        if(!Utils.isNoB(engineerNameStr)) {
                            let nameStr = null;
                            let engineerNames = engineerNameStr.split("、");
                            for(let i = 0; i < engineerNames.length; i++) {
                                let name = engineerNames[i];
                                if(name != engineerName) {
                                    if(nameStr == null) {
                                        nameStr = name;
                                    } else if(nameStr.indexOf(name) < 0) {
                                        nameStr = nameStr + '、' + name;
                                    }
                                }
                            }
                            servcWorkVoucher.engineerNames = nameStr;
                        }
                        self.servcWorkVoucher = servcWorkVoucher;
                    }
                })
            },
            exportPdf: function () {
                let self = this;
                let result = self.$refs.swb_servc_work_add_item_list.getHtml() || '';
                showHtmlToPdfDlg(self.title, result, null);
            },
            getHtml: function () {
                return this.$el.outerHTML;

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherDetailerForExport.vue